import { Routes } from '@angular/router';
import { NotLoggedLayoutComponent } from './shared/layouts/not-logged-layout/not-logged-layout.component';
import { CandidatLayoutComponent } from './shared/layouts/candidat-layout/candidat-layout.component';
import { EtablissementLayoutComponent } from './shared/layouts/etablissement-layout/etablissement-layout.component';
import { authGuard } from './core/guard/auth.guard';
import { loggedGuard } from "./core/guard/logged.guard";
import { candidateGuard } from "./core/guard/candidat.guard";
import { establishmentGuard } from "./core/guard/establishment.guard";
import { AgencyDashComponent } from "./core/agency/agency-dash/agency-dash.component";
import { AgencyEstablishmentComponent } from "./core/agency/agency-establishment/agency-establishment.component";
import { AgencyLayoutXontainerComponent } from "./core/agency/agency-layout-xontainer/agency-layout-xontainer.component";
import {
  AgencyEtabMissionsDetailsComponent
} from "./core/agency/agency-etab-missions-details/agency-etab-missions-details.component";
import {
  AgencyEtabMissionsAddComponent
} from "./core/agency/agency-etab-missions-add/agency-etab-missions-add.component";
import { AgencyUsersComponent } from './core/agency/agency-users/agency-users.component';
import { AgencyManagementComponent } from './core/agency/agency-management/agency-management.component';
import { AgencyCandidatesComponent } from "./core/agency/agency-candidates/agency-candidates.component";
import {
  AgencyCandidateMissionsDetailsComponent
} from "./core/agency/agency-candidate-missions-details/agency-candidate-missions-details.component";
import {
  MissionValidationComponent
} from "./core/agency/agency-etab-missions-details/encour-component/components/mission-validation/mission-validation.component";
import { MissionsManagementComponent } from './core/agency/missions-management/missions-management.component';
import { fragmentActionsComponent } from './core/agency/fragmented-mission/fragment-actions.component';
import { PrivacyPolicyComponent } from './core/agency/components/privacy-policy/privacy-policy.component';
import { AccountActivationPageComponent } from './account-activation-page/account-activation-page.component';
import { AgencyEstablishmentEditComponent } from './core/agency/agency-establishment-edit/agency-establishment-edit.component';
import { ProfileComponent } from './pages/etablissement/profile/profile.component';
import { WeeklyReportsComponent } from './core/agency/weekly-reports/weekly-reports.component';
import { AgencyDirectAssignComponent } from './core/agency/agency-direct-assign/agency-direct-assign.component';
import { WeeklyHoursListComponent } from './core/agency/weekly-hours/weekly-hours-list.component';
import { WeeklyHoursDetailComponent } from './core/agency/weekly-hours/weekly-hours-detail.component';
import { PayrollPeriodsComponent } from './core/agency/payroll/payroll-periods.component';
import { PayrollPeriodDetailComponent } from './core/agency/payroll/payroll-period-detail.component';

export const routes: Routes = [
  {
    path: 'account/activate',
    component: AccountActivationPageComponent,
  },
  { path: '', redirectTo: '/agency/dash', pathMatch: 'full' },
  {
    path: 'agency',
    component: AgencyLayoutXontainerComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'establishment/edit/:id',
        component: AgencyEstablishmentEditComponent,
      },
      {
        path: 'dash',
        component: AgencyDashComponent,
      },
      {
        path: 'establishment',
        component: AgencyEstablishmentComponent,
      }, {
        path: 'candidates',
        component: AgencyCandidatesComponent,
      },
      {
        path: 'candidates/edit/:id',
        component: ProfileComponent,
      },
      {
        path: 'users',
        component: AgencyUsersComponent,
      },
      {
        path: 'agencies',
        component: AgencyManagementComponent,
      },
      {
        path: 'missions',
        component: MissionsManagementComponent,
      },
      {
        path: 'weekly-reports',
        component: WeeklyReportsComponent,
      },
      {
        path: 'weekly-hours',
        component: WeeklyHoursListComponent,
      },
      {
        path: 'weekly-hours/:id',
        component: WeeklyHoursDetailComponent,
      },
      {
        path: 'payroll',
        component: PayrollPeriodsComponent,
      },
      {
        path: 'payroll/:id',
        component: PayrollPeriodDetailComponent,
      },
      {
        path: 'direct-assign',
        component: AgencyDirectAssignComponent,
      },
      {
        path: 'mission-by-establishment/:establishmentId',
        component: AgencyEtabMissionsAddComponent,
      },
      {
        path: 'mission-by-establishment/:establishmentId/:missionId',
        component: AgencyEtabMissionsAddComponent,
        data: { breadcrumb: { alias: 'modify' } },

      },
      {
        path: 'details-establishment/:establishmentId',
        component: AgencyEtabMissionsDetailsComponent,
        children: []
      }, {
        path: 'details-candidate/:candidatId/:typePosteId',
        component: AgencyCandidateMissionsDetailsComponent,
        children: []
      },
      {
        path: 'validation/:id',
        component: MissionValidationComponent,
        data: { breadcrumb: { alias: 'Validation' } },
      },
      {
        path: 'fragmented-mision/:id',
        component: fragmentActionsComponent,
        data: { breadcrumb: { alias: 'Fragment actions' } },
      },
      {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent,
        data: {},
      },
    ],
  },

  {
    path: '',
    component: NotLoggedLayoutComponent,
    canActivate: [loggedGuard],
    children: [
      {
        path: 'home',
        loadChildren: () =>
          import('./home/home.module').then((m) => m.HomeModule),
      },
      {
        path: '',
        loadChildren: () =>
          import('./core/core.module').then((m) => m.CoreModule),
      },
      {
        path: 'etablissement',
        loadChildren: () =>
          import('./pages/etablissement/etablissement.module').then(
            (m) => m.EtablissementModule
          ),
      },
    ],
  },
  {
    path: '',
    component: CandidatLayoutComponent,
    canActivate: [authGuard, candidateGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/candidat/candidat.module').then(
            (m) => m.CandidatModule
          ),
      },
      // {path : 'candidat' , redirectTo : '/candidat/accueil', pathMatch : 'full' },
    ],
  },
  {
    path: '',
    component: EtablissementLayoutComponent,
    canActivate: [authGuard, establishmentGuard],
    children: [
      {
        path: 'dashboard',
        data: { breadcrumb: { skip: true } },
        loadChildren: () =>
          import('./pages/etablissement/etablissement.module').then(
            (m) => m.EtablissementModule
          ),
      },
    ],
  },

  { path: '**', redirectTo: '/agency/dash' },
];
